<template>
  <ul class="payment_icons" ref="payment_icons" :style="wrapstyle">
    <!-- <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        viewBox="0 0 38 24"
        width="38"
        height="24"
        role="img"
        aria-labelledby="pi-bitcoin"
      >
        <title id="pi-bitcoin">Bitcoin</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        ></path>
        <path
          fill="#fff"
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
        ></path>
        <path
          fill="#EDA024"
          d="M21.6 4.4c-4.2-1.4-8.7.8-10.2 5s.8 8.7 5 10.2 8.7-.8 10.2-5c1.4-4.2-.8-8.7-5-10.2z"
        ></path>
        <path
          fill="#fff"
          d="M16.1 8.3l.3-1c.6.2 1.3.4 1.9.7.2-.5.4-1 .5-1.6l.9.3-.5 1.5.8.3.5-1.5.9.3c-.2.5-.4 1-.5 1.6l.4.2c.3.2.6.4.9.7.3.3.4.6.5 1 0 .3 0 .6-.2.9-.2.5-.5.8-1.1.9h-.2c.2.1.3.2.4.4.4.4.5.8.4 1.4 0 .1 0 .2-.1.3 0 .1 0 .1-.1.2-.1.2-.2.3-.2.5-.3.5-.8.9-1.5.9-.5 0-1 0-1.4-.1l-.4-.1c-.2.5-.4 1-.5 1.6l-.9-.3c.2-.5.4-1 .5-1.5l-.8-.3c-.2.5-.4 1-.5 1.5l-.9-.3c.2-.5.4-1 .5-1.6l-1.9-.6.6-1.1c.2.1.5.2.7.2.2.1.4 0 .5-.2L17 9.3v-.1c0-.3-.1-.5-.4-.5 0-.2-.2-.3-.5-.4zm1.2 6c.5.2.9.3 1.3.4.3.1.5.1.8.1.2 0 .3 0 .5-.1.5-.3.6-1 .2-1.4l-.6-.5c-.3-.2-.7-.3-1.1-.4-.1 0-.3-.1-.4-.2l-.7 2.1zm1-3.1c.3.1.5.2.7.2.3.1.6.2.9.1.4 0 .7-.1.8-.5.1-.3.1-.6 0-.8-.1-.2-.3-.3-.5-.4-.3-.2-.6-.3-1-.4l-.3-.1c-.1.7-.4 1.3-.6 1.9z"
        ></path>
      </svg>

      <svg
        viewBox="0 0 38 24"
        width="38"
        height="24"
        style="background-color: white; border-radius: 2px"
      >
        <title id="pagantis">Pagantis</title>
        <style type="text/css">
          .st0 {
            fill: url(#SVGID_1_);
          }
          .st1 {
            fill: url(#SVGID_2_);
            enable-background: new;
          }
          .st2 {
            fill: url(#SVGID_3_);
          }
        </style>
        <g>
          <g>
            <linearGradient
              id="SVGID_1_"
              gradientUnits="userSpaceOnUse"
              x1="11.5643"
              y1="19.3292"
              x2="21.0314"
              y2="19.3292"
            >
              <stop offset="0" style="stop-color: #c7e5f4"></stop>
              <stop offset="1" style="stop-color: #d5ebf8"></stop>
            </linearGradient>
            <path
              class="st0"
              d="M13.2,17.3c-0.3,0.1-0.9,0.2-1.2,0.5c-0.1,0.1-0.4,0.4-0.4,1c0,0,0.7,0.4,0.7,0.4l0,0c0,0,5.7,3.4,7.7,4.3
			c0.5,0.2,1-0.1,1-0.6l0-7.7L13.2,17.3z"
            ></path>
          </g>
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="11.6161"
            y1="7.8224"
            x2="27.1435"
            y2="7.8224"
          >
            <stop offset="0" style="stop-color: #8cc6ed"></stop>
            <stop offset="1" style="stop-color: #68c2eb"></stop>
          </linearGradient>
          <path
            class="st1"
            d="M21,11.3l0,3.8l4.7-1.1c0.9-0.1,1.4-0.6,1.4-1.4l0-0.1l0-3.9l0-6.6c0-1.1-0.9-1.5-1.3-1.5
		c-3.5,0.6-14.2,4.2-14.1,4.2c0,0-0.1,0.6,0.8,1.2c0.1,0,5.5,3.1,5.5,3.1s1.7,0.9,1.8,1C20.3,10.1,21,10.5,21,11.3z"
          ></path>
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1="10.8565"
            y1="11.7255"
            x2="21.0342"
            y2="11.7255"
          >
            <stop offset="0" style="stop-color: #38abe2"></stop>
            <stop offset="0.9997" style="stop-color: #1a9fd6"></stop>
          </linearGradient>
          <path
            class="st2"
            d="M21,15.1l0-3.8c0-0.8-0.7-1.2-1.1-1.4c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.2-0.1C18.9,9.4,18,8.9,18,8.9
		S13.9,6.6,12.7,6c-0.1-0.1-0.6-0.3-0.8-0.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.1-0.3-0.1-0.4c0,0,0-0.1,0-0.1
		c-0.4,0.2-0.7,0.8-0.7,1.1v5.5v0V17l0,0.5c0,0.3,0,0.7,0.7,1.2c0-0.2,0.1-0.7,0.4-1c0.4-0.3,1-0.5,1.2-0.5L21,15.1L21,15.1L21,15.1
		z"
          ></path>
        </g>
      </svg>
    </li> -->
  </ul>
</template>
<script>
export default {
  props: {
    paylist: {
      type: [Array],
      default: [],
    },
    wrapstyle: {
      type: [Object],
      default: ()=>{},
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.paylist.forEach((item) => {
      switch (item) {
        case "Visa":
          this.$(this.$refs.payment_icons)
            .append(` <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        viewBox="0 0 38 24"
        role="img"
        width="38"
        height="24"
        aria-labelledby="pi-visa"
      >
        <title id="pi-visa">Visa</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        ></path>
        <path
          fill="#fff"
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
        ></path>
        <path
          d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
          fill="#142688"
        ></path>
      </svg>
    </li>`);
          break;
        case "Maestro":
          this.$(this.$refs.payment_icons)
            .append(`   <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        viewBox="0 0 38 24"
        width="38"
        height="24"
        role="img"
        aria-labelledby="pi-maestro"
      >
        <title id="pi-maestro">Maestro</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        ></path>
        <path
          fill="#fff"
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
        ></path>
        <circle fill="#EB001B" cx="15" cy="12" r="7"></circle>
        <circle fill="#00A2E5" cx="23" cy="12" r="7"></circle>
        <path
          fill="#7375CF"
          d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
        ></path>
      </svg>
    </li>`);
          break;
        case "Mastercard":
          this.$(this.$refs.payment_icons)
            .append(`    <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        viewBox="0 0 38 24"
        role="img"
        width="38"
        height="24"
        aria-labelledby="pi-master"
      >
        <title id="pi-master">Mastercard</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        ></path>
        <path
          fill="#fff"
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
        ></path>
        <circle fill="#EB001B" cx="15" cy="12" r="7"></circle>
        <circle fill="#F79E1B" cx="23" cy="12" r="7"></circle>
        <path
          fill="#FF5F00"
          d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
        ></path>
      </svg>
    </li>`);

          break;
        case "American Express":
          this.$(this.$refs.payment_icons)
            .append(`    <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        role="img"
        viewBox="0 0 38 24"
        width="38"
        height="24"
        aria-labelledby="pi-american_express"
      >
        <title id="pi-american_express">American Express</title>
        <g fill="none">
          <path
            fill="#000"
            d="M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z"
            opacity=".07"
          ></path>
          <path
            fill="#006FCF"
            d="M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1"
          ></path>
          <path
            fill="#FFF"
            d="M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z"
          ></path>
        </g>
      </svg>
    </li>`);

          break;
        case "PayPal":
          this.$(this.$refs.payment_icons)
            .append(`    <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        viewBox="0 0 38 24"
        width="38"
        height="24"
        role="img"
        aria-labelledby="pi-paypal"
      >
        <title id="pi-paypal">PayPal</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        ></path>
        <path
          fill="#fff"
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
        ></path>
        <path
          fill="#003087"
          d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"
        ></path>
        <path
          fill="#3086C8"
          d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"
        ></path>
        <path
          fill="#012169"
          d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"
        ></path>
      </svg>
    </li>`);

          break;
        case "Shop Pay":
          this.$(this.$refs.payment_icons)
            .append(`    <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        role="img"
        viewBox="0 0 38 24"
        width="38"
        height="24"
        aria-labelledby="pi-shopify_pay"
      >
        <title id="pi-shopify_pay">Shop Pay</title>
        <path
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
          fill="#000"
        ></path>
        <path
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z"
          fill="#5A31F4"
        ></path>
        <path
          d="M21.382 9.713c0 1.668-1.177 2.858-2.821 2.858h-1.549a.133.133 0 00-.12.08.127.127 0 00-.01.049v2.192a.129.129 0 01-.13.129h-1.084a.13.13 0 01-.13-.13V6.986a.127.127 0 01.08-.12.129.129 0 01.05-.01h2.9c1.637 0 2.814 1.19 2.814 2.858v-.001zm-1.352 0c0-.958-.658-1.658-1.55-1.658h-1.468a.13.13 0 00-.13.13v3.05a.127.127 0 00.038.092.129.129 0 00.092.038h1.468c.892.005 1.55-.695 1.55-1.652zm1.674 3.791a1.527 1.527 0 01.647-1.317c.423-.316 1.084-.48 2.055-.514l1.033-.036v-.303c0-.607-.41-.863-1.068-.863-.658 0-1.075.231-1.17.61a.127.127 0 01-.125.09h-1.022a.13.13 0 01-.126-.092.125.125 0 01-.004-.055c.152-.898.904-1.58 2.494-1.58 1.692 0 2.303.783 2.303 2.276v3.172a.13.13 0 01-.132.129h-1.03a.13.13 0 01-.13-.13v-.236a.096.096 0 00-.061-.091.1.1 0 00-.107.022c-.31.334-.808.575-1.607.575-1.175 0-1.95-.607-1.95-1.657zm3.735-.687v-.246l-1.339.07c-.705.036-1.115.326-1.115.816 0 .444.376.69 1.034.69.893 0 1.42-.48 1.42-1.33zm2.316 4.6v-.919a.13.13 0 01.049-.1.132.132 0 01.108-.027c.158.029.318.044.479.044a1.229 1.229 0 001.245-.876l.067-.211a.133.133 0 000-.088l-2.145-5.471a.13.13 0 01.06-.165.13.13 0 01.062-.015h1.04a.132.132 0 01.123.085l1.456 3.859a.131.131 0 00.125.088.133.133 0 00.125-.088l1.265-3.848a.13.13 0 01.126-.09h1.076a.134.134 0 01.132.116.134.134 0 01-.008.063l-2.295 6.076c-.528 1.413-1.433 1.773-2.43 1.773a1.959 1.959 0 01-.561-.066.132.132 0 01-.1-.14h.001zM8.57 6.4a5.363 5.363 0 00-3.683 1.427.231.231 0 00-.029.31l.618.839a.236.236 0 00.362.028 3.823 3.823 0 012.738-1.11c2.12 0 3.227 1.584 3.227 3.15 0 1.7-1.163 2.898-2.835 2.921-1.292 0-2.266-.85-2.266-1.974a1.908 1.908 0 01.713-1.48.231.231 0 00.033-.324l-.65-.815a.236.236 0 00-.339-.034 3.43 3.43 0 00-.942 1.183 3.39 3.39 0 00-.337 1.47c0 1.935 1.655 3.452 3.775 3.464h.03c2.517-.032 4.337-1.884 4.337-4.415 0-2.247-1.667-4.64-4.752-4.64z"
          fill="#fff"
        ></path>
      </svg>
    </li>`);

          break;
        case "Apple Pay":
          this.$(this.$refs.payment_icons)
            .append(`    <li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        version="1.1"
        role="img"
        x="0"
        y="0"
        width="38"
        height="24"
        viewBox="0 0 165.521 105.965"
        xml:space="preserve"
        aria-labelledby="pi-apple_pay"
      >
        <title id="pi-apple_pay">Apple Pay</title>
        <path
          fill="#000"
          d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"
        ></path>
        <path
          fill="#FFF"
          d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"
        ></path>
        <g>
          <g>
            <path
              fill="#000"
              d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"
            ></path>
            <path
              fill="#000"
              d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"
            ></path>
          </g>
          <g>
            <path
              fill="#000"
              d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"
            ></path>
            <path
              fill="#000"
              d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"
            ></path>
            <path
              fill="#000"
              d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"
            ></path>
          </g>
        </g>
      </svg>
    </li>`);

          break;
        case "Google Pay":
          this.$(this.$refs.payment_icons)
            .append(`<li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
      <svg
        role="img"
        viewBox="0 0 38 24"
        width="38"
        height="24"
        aria-labelledby="pi-google_pay"
      >
        <title id="pi-google_pay">Google Pay</title>
        <path
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
          fill="#000"
          opacity=".07"
        ></path>
        <path
          d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
          fill="#FFF"
        ></path>
        <path
          d="M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z"
          fill="#5F6368"
        ></path>
        <path
          d="M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z"
          fill="#4285F4"
        ></path>
        <path
          d="M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z"
          fill="#34A853"
        ></path>
        <path
          d="M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z"
          fill="#FBBC04"
        ></path>
        <path
          d="M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171a2.715 2.715 0 0 1 2.55-1.875z"
          fill="#EA4335"
        ></path>
      </svg>
    </li>`);

          break;
        case "Dicover":
          this.$(this.$refs.payment_icons)
            .append(`<li class="payment_icons--item" style="padding: 1.5px;display:inline-block; ">
            <img width="38px" height="24px" style="border:1px solid #EEE;border-radius:3px;" src="data:image/png;base64,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">
          
    </li>`);
          break;
          case "Diners Club International":
          this.$(this.$refs.payment_icons)
            .append(`<li class="payment_icons--item" style="padding: 1.5px;display:inline-block;">
          <img  width="38px" height="24px" style="border:1px solid #EEE;border-radius:3px;" src="data:image/png;base64,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">
    </li>`);

          break;
      }
    });
  },
};
</script>
<style scoped lang='scss'>
.payment_icons {
  display: inline-block;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
@media screen and (max-width: 746px) {
  .payment_icons{
    display: block;
    float: none !important;
    margin-left:30px ;
  }
  
}
</style>